import React , {useContext} from "react";
import "./Contact.scss";
import {skillsSection} from "../../portfolio";
import { contactInfo, socialMediaLinks } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function  Contact (){
    const {isDark} = useContext(StyleContext);
  
    if (!skillsSection.display) return null;
  return (
    <section className={isDark ? "dark-mode main contact-editorial": "main contact-editorial"} id="contact">
        <div className="editorial-heading">
          <span>05 / CONTACT</span>
          <h2>{contactInfo.title}✦</h2>
        </div>

        <div className="contact-editorial-grid">

          {/* LEFT */}
          <div className="contact-copy">
            <p className="contact-description">
              Always happy to talk tech, hear about an interesting project,
              or the next opportunity — just message me.
            </p>
            <a
              className="contact-email"
              href={`mailto:${contactInfo.email_address}`}
            >
              <span className="contact-email-icon">
                <i className="fas fa-envelope"></i>
              </span>

              <span>{contactInfo.email_address}</span>
            </a>

            <div className="contact-socials">

              {socialMediaLinks.github && (
                <a
                  href={socialMediaLinks.github}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-github"></i>
                  <span>GitHub</span>
                </a>
              )}

              {socialMediaLinks.linkedin && (
                <a
                  href={socialMediaLinks.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin"></i>
                  <span>LinkedIn</span>
                </a>
              )}

              {socialMediaLinks.gmail && (
                <a
                  href={`mailto:${socialMediaLinks.gmail}`}
                >
                  <i className="fas fa-envelope"></i>
                  <span>Email</span>
                </a>
              )}

            </div>
          </div>

          {/* RIGHT */}
          <div className="contact-art">

            <div className="contact-blueprint">
              <span className="dimension dimension-vertical">
                120
              </span>

              <span className="blueprint-cross cross-one">
                +
              </span>

              <span className="blueprint-cross cross-two">
                +
              </span>
            </div>

            <img
              src={require("../../assets/images/talktome.png")}
              alt="Desk with laptop, books and botanical illustration"
            />

            <div className="contact-art-footer">
              <span></span>
              <strong>SH / 01</strong>
            </div>

          </div>

        </div>
    </section>
  );
}